import { render, staticRenderFns } from "./CatapultBannerProductCard.vue?vue&type=template&id=1c81d93e&scoped=true"
import script from "./CatapultBannerProductCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./CatapultBannerProductCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CatapultBannerProductCard.vue?vue&type=style&index=0&id=1c81d93e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c81d93e",
  null
  
)

export default component.exports